import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  connect() {
    if(!this.check){
      sorttable.makeSortable(this.element)
      this.check = true
    }
  }
}